export default __webpack_public_path__ + "static/media/iphone.b42af6e4.png";